import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Icons/leaderboard-up.svg'
import _imports_1 from '@/assets/img/Icons/leaderboard-down.svg'


const _withScopeId = n => (_pushScopeId("data-v-2a73363c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "avatar-title" }
const _hoisted_2 = {
  key: 0,
  class: "avatar"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "group-name" }
const _hoisted_5 = {
  key: 0,
  class: "title-rank"
}
const _hoisted_6 = { class: "response-nps" }
const _hoisted_7 = { class: "response" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "TOTAL RESPONSES", -1))
const _hoisted_9 = { class: "number" }
const _hoisted_10 = { class: "nps-block" }
const _hoisted_11 = { class: "nps" }
const _hoisted_12 = {
  key: 0,
  class: "change"
}
const _hoisted_13 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_14 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_15 = { class: "number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormattedNumber = _resolveComponent("FormattedNumber")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["brief-info", { 'has-rank': _ctx.showRank }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.currentGroupAvatar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _ctx.avatarUrl,
              alt: "avatar",
              class: "avatar-img"
            }, null, 8, _hoisted_3)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.name), 1),
        (_ctx.npsInsightsSummary.rank)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.npsInsightsSummary.rank) + _toDisplayString(_ctx.getOrdinalRank(_ctx.npsInsightsSummary.rank)) + " within " + _toDisplayString(_ctx.npsInsightsSummary.rankFieldLabel), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_FormattedNumber, {
            number: _ctx.npsInsightsSummary.total
          }, null, 8, ["number"])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.getNpsRounded(_ctx.npsInsightsSummary.nps)), 1),
        (!_ctx.npsInsightsSummary.isFiveScore)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (_ctx.npsInsightsSummary.change >= 0)
                ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                : (_openBlock(), _createElementBlock("img", _hoisted_14)),
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.getNpsRounded(_ctx.npsInsightsSummary.change)), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (!!_ctx.isLoadingInsightsData)
      ? (_openBlock(), _createBlock(_component_Loading, {
          key: 0,
          loading: ""
        }))
      : _createCommentVNode("", true)
  ], 2))
}